// extracted by mini-css-extract-plugin
module.exports = {"not-found":"NotFoundPage-module--not-found--3zIIZ","title-mobile":"NotFoundPage-module--title-mobile--hFBSz","not-found__text":"NotFoundPage-module--not-found__text--1X4FL"};